import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerLiquidationsMenuMobileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.33332 11.3333L7.99999 10.6667L7.66666 11.3333H8.33332Z",
			stroke: "#1A1B23",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.33332 11.3333L7.99999 10.6667L7.66666 11.3333H8.33332Z",
			stroke: "white",
			strokeOpacity: .5,
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.99999 14.6667C10.1768 14.6667 10.3464 14.5964 10.4714 14.4714C10.5964 14.3464 10.6667 14.1768 10.6667 14V13.3333C10.9178 13.3332 11.1638 13.2621 11.3763 13.1283C11.5888 12.9945 11.7592 12.8034 11.8679 12.577C11.9765 12.3506 12.0191 12.0981 11.9905 11.8486C11.962 11.5991 11.8636 11.3627 11.7067 11.1667C12.4706 10.4282 12.9966 9.47836 13.2172 8.43895C13.4377 7.39955 13.3428 6.31795 12.9445 5.33287C12.5462 4.34779 11.8628 3.50412 10.9818 2.91006C10.1009 2.316 9.06254 1.99862 7.99999 1.99862C6.93745 1.99862 5.89912 2.316 5.01816 2.91006C4.13719 3.50412 3.45376 4.34779 3.05549 5.33287C2.65721 6.31795 2.56226 7.39955 2.78281 8.43895C3.00336 9.47836 3.52934 10.4282 4.29333 11.1667C4.13637 11.3627 4.03797 11.5991 4.00945 11.8486C3.98093 12.0981 4.02346 12.3506 4.13213 12.577C4.2408 12.8034 4.4112 12.9945 4.62371 13.1283C4.83622 13.2621 5.0822 13.3332 5.33333 13.3333V14C5.33333 14.1768 5.40356 14.3464 5.52859 14.4714C5.65361 14.5964 5.82318 14.6667 5.99999 14.6667H9.99999Z",
			stroke: "#1A1B23",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.99999 14.6667C10.1768 14.6667 10.3464 14.5964 10.4714 14.4714C10.5964 14.3464 10.6667 14.1768 10.6667 14V13.3333C10.9178 13.3332 11.1638 13.2621 11.3763 13.1283C11.5888 12.9945 11.7592 12.8034 11.8679 12.577C11.9765 12.3506 12.0191 12.0981 11.9905 11.8486C11.962 11.5991 11.8636 11.3627 11.7067 11.1667C12.4706 10.4282 12.9966 9.47836 13.2172 8.43895C13.4377 7.39955 13.3428 6.31795 12.9445 5.33287C12.5462 4.34779 11.8628 3.50412 10.9818 2.91006C10.1009 2.316 9.06254 1.99862 7.99999 1.99862C6.93745 1.99862 5.89912 2.316 5.01816 2.91006C4.13719 3.50412 3.45376 4.34779 3.05549 5.33287C2.65721 6.31795 2.56226 7.39955 2.78281 8.43895C3.00336 9.47836 3.52934 10.4282 4.29333 11.1667C4.13637 11.3627 4.03797 11.5991 4.00945 11.8486C3.98093 12.0981 4.02346 12.3506 4.13213 12.577C4.2408 12.8034 4.4112 12.9945 4.62371 13.1283C4.83622 13.2621 5.0822 13.3332 5.33333 13.3333V14C5.33333 14.1768 5.40356 14.3464 5.52859 14.4714C5.65361 14.5964 5.82318 14.6667 5.99999 14.6667H9.99999Z",
			stroke: "white",
			strokeOpacity: .5,
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 8.66667C10.3682 8.66667 10.6667 8.36819 10.6667 8C10.6667 7.63181 10.3682 7.33333 10 7.33333C9.63182 7.33333 9.33334 7.63181 9.33334 8C9.33334 8.36819 9.63182 8.66667 10 8.66667Z",
			stroke: "#1A1B23",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 8.66667C10.3682 8.66667 10.6667 8.36819 10.6667 8C10.6667 7.63181 10.3682 7.33333 10 7.33333C9.63182 7.33333 9.33334 7.63181 9.33334 8C9.33334 8.36819 9.63182 8.66667 10 8.66667Z",
			stroke: "white",
			strokeOpacity: .5,
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.00001 8.66667C6.3682 8.66667 6.66668 8.36819 6.66668 8C6.66668 7.63181 6.3682 7.33333 6.00001 7.33333C5.63182 7.33333 5.33334 7.63181 5.33334 8C5.33334 8.36819 5.63182 8.66667 6.00001 8.66667Z",
			stroke: "#1A1B23",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.00001 8.66667C6.3682 8.66667 6.66668 8.36819 6.66668 8C6.66668 7.63181 6.3682 7.33333 6.00001 7.33333C5.63182 7.33333 5.33334 7.63181 5.33334 8C5.33334 8.36819 5.63182 8.66667 6.00001 8.66667Z",
			stroke: "white",
			strokeOpacity: .5,
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgHypertrackerLiquidationsMenuMobileIcon;
